import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const stack: SxStyle = {
  width: '100%',
  gap: (p) => p.spacing(1.25),
};

export const paymentFailedCard: SxStyle = {
  borderColor: (p) => p.palette.error[200],
  background: (p) => p.palette.error[50],
  padding: (p) => p.spacing(0.5, 1),
};
